<template>
   <div class="menu-post" :class="{ last: isLast, 'has-long-price': priceArray.length > 1 }">
      <div class="menu-post-desc">
         <h4>
           <span class="menu-title" :style="{ backgroundColor: null }">{{ name | preposFix }}</span>
           <span class="menu-dots"></span>
           <span class="menu-price nowrap" :style="{ backgroundColor: null }">
             <span v-for="(p, i) in priceArray"><span
               v-if="i !== 0"><smp-hair />/<smp-hair /></span>{{ p }}<smp-hair />€</span>
           </span>
         </h4>

         <div v-if="text || allergens.length > 0 || weight" class="menu-text">
           {{ text | preposFix }}
           <span class="nowrap">
             <span v-if="weight" class="b">&nbsp;{{ weight }}</span>
             <span
               v-if="allergens.length > 0"
               :title="`alergény: ${ allergensText }`"
               class="nowrap"
             >[{{ allergens.join(', ') }}]</span>
           </span>
         </div>
      </div>
   </div>
</template>

<script>
  import allergens from '@/data/allergens'

  export default {
    props: {
      allergens: {
        type: Array,
        default: () => [],
      },

      isLast: {
        type: Boolean,
      },

      name: {
        type: String,
        required: true,
      },

      price: {
        type: [String, Number],
        required: true,
      },

      text: {
        type: String,
      },

      weight: {
        type: String,
      },
    },

    data () {
      return {
        backgroundColor: 'white'
      }
    },

    computed: {
      priceArray () {
        return String(this.price)
          .replace(/\,/g, '.')
          .split('/')
          .map(p => Number(p).toFixed(2).replace(/\./g, ','))
      },

      allergensText () {
        return this.allergens.map(a => allergens[a - 1]).join(', ')
      }
    },

    methods: {
      setClosestBackgroundColor () {
        let color
        let el = this.$el
        const transparent = 'rgba(0, 0, 0, 0)'

        while (el != null) {
          color = getComputedStyle(el).backgroundColor
          if (color !== transparent) {
            this.backgroundColor = color
            return
          }

          el = el.parentNode
        }
      },
    },

    mounted () {
      this.setClosestBackgroundColor()
    },

    updated () {
      this.setClosestBackgroundColor()
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/MenuItem.vue?bfef85d8